import { render, staticRenderFns } from "./PasswordChanged.vue?vue&type=template&id=1bd05642&scoped=true&"
import script from "./PasswordChanged.vue?vue&type=script&lang=js&"
export * from "./PasswordChanged.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChanged.vue?vue&type=style&index=0&id=1bd05642&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd05642",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
